// src/main.js
import './styles.css';
import { isAuthenticated, getUserRole, onSessionExpired } from './lib/auth.js';
import { initRouter } from './router.js';
import { initObservability } from './lib/observability.js';

/* global __BUILD_ID__ */

async function init() {
  initObservability();
  const authenticated = await isAuthenticated();

  if (!authenticated) {
    // Let the router handle unauthenticated visitors — #/ maps to login
  } else {
    const role = await getUserRole();
    const currentHash = window.location.hash;

    if (!currentHash || currentHash === '#/' || currentHash === '#/login') {
      const roleHomes = {
        agent: '#/ops/',
        ceo: '#/ops/',
        reviewer: '#/dashboard/',
        ops: '#/ops/'
      };
      window.location.hash = roleHomes[role] || '#/login';
    }
  }

  initRouter();

  onSessionExpired(() => {
    const toastDiv = document.createElement('div');
    toastDiv.className = 'fixed bottom-20 right-4 bg-white text-gray-900 border border-gray-200 px-4 py-3 rounded-lg shadow-lg z-50';
    toastDiv.textContent = 'Session expired \u2014 please log in again';
    document.body.appendChild(toastDiv);

    setTimeout(() => {
      toastDiv.remove();
      window.location.hash = '#/login';
    }, 3000);
  });
}

init();
